import { Typography } from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useStores } from "../../../models/helpers/useStores";
import { Colors } from "../../../theme";
import { useTranslation } from "react-i18next";

const SelectedBar = () => {
  const location = useLocation();
  const {
    appStore: { userProfile, getACLGroup },
  } = useStores();
  const {t} = useTranslation() as any

  const { aclChecklist } = useMemo(() => {
    const aclGroup = getACLGroup()?.[userProfile?.PrimaryGroup?.GroupId ?? 0];
    return {
      aclChecklist: aclGroup?.task,
    };
  }, [userProfile]);

  // State for selected tab index
  const [selectedIndex, setSelectedIndex] = useState<number>(() => {
    const currentPath = location.pathname;
    if (currentPath.includes("/checklist/my")) return 0;
    if (currentPath.includes("/checklist/everyone/all-tasks")) return 1;
    if (currentPath.includes("/checklist/templates/checklists")) return 2;
    if (currentPath.includes("/checklist/reports/checklist")) return 3;
    return -1;
  });

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes("/checklist/my")) setSelectedIndex(0);
    if (currentPath.includes("/checklist/everyone/all-tasks")) setSelectedIndex(1);
    if (currentPath.includes("/checklist/templates/checklists")) setSelectedIndex(2);
    if (currentPath.includes("/checklist/reports/checklist")) setSelectedIndex(3);
  }, [location]);

  return (
    <>
      <Link
        to="/checklist/my"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "100%",
          backgroundColor: selectedIndex === 0 ? "#DCDADB" : "transparent",
          cursor: "pointer",
          marginTop: "40px",
          textDecoration: "none",
          padding: "10px 20px",
          fontWeight: selectedIndex === 0 ? "600" : "400",
          fontSize: "13px",
          whiteSpace: "nowrap",
        }}
        onClick={() => setSelectedIndex(0)}
      >
        <Typography
          style={{
            whiteSpace: "nowrap",
            fontWeight: selectedIndex === 0 ? "500" : "400",
          }}
          variant="subtitle2"
          color={Colors.black}
        >
          {t("26_00_mine")}
        </Typography>
      </Link>

      {aclChecklist?.ViewAll !== false && (
        <Link
          to="/checklist/everyone/all-tasks"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
            backgroundColor: selectedIndex === 1 ? "#DCDADB" : "transparent",
            cursor: "pointer",
            textDecoration: "none",
            padding: "10px 20px",
            fontWeight: selectedIndex === 1 ? "600" : "400",
            fontSize: "13px",
            whiteSpace: "nowrap",
          }}
          onClick={() => setSelectedIndex(1)}
        >
          <Typography
            style={{
              whiteSpace: "nowrap",
              fontWeight: selectedIndex === 1 ? "500" : "400",
            }}
            variant="subtitle2"
            color={Colors.black}
          >
            {t("00_06_everyone")}
          </Typography>
        </Link>
      )}

      {aclChecklist?.ViewTemplate !== false && (
        <Link
          to="/checklist/templates/checklists"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
            backgroundColor: selectedIndex === 2 ? "#DCDADB" : "transparent",
            cursor: "pointer",
            textDecoration: "none",
            padding: "10px 20px",
            fontWeight: selectedIndex === 2 ? "600" : "400",
            fontSize: "13px",
            whiteSpace: "nowrap",
          }}
          onClick={() => setSelectedIndex(2)}
        >
          <Typography
            style={{
              whiteSpace: "nowrap",
              fontWeight: selectedIndex === 2 ? "500" : "400",
            }}
            variant="subtitle2"
            color={Colors.black}
          >
            {t("26_00_templates")}
          </Typography>
        </Link>
      )}

      {aclChecklist?.ViewAll !== false && (
        <Link
          to="/checklist/reports/checklist"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
            backgroundColor: selectedIndex === 3 ? "#DCDADB" : "transparent",
            cursor: "pointer",
            textDecoration: "none",
            padding: "10px 20px",
            fontWeight: selectedIndex === 3 ? "600" : "400",
            fontSize: "13px",
            whiteSpace: "nowrap",
          }}
          onClick={() => setSelectedIndex(3)}
        >
          <Typography
            style={{
              whiteSpace: "nowrap",
              fontWeight: selectedIndex === 3 ? "500" : "400",
            }}
            variant="subtitle2"
            color={Colors.black}
          >
            {t("00_01_report")}
          </Typography>
        </Link>
      )}
    </>
  );
};

export default SelectedBar;
